import Emoji from '../store/schema/Emoji';
import getEmojiList from './getEmojiList';
import { computed, IComputedValue } from 'mobx';

let emojiMap: IComputedValue<{ [key: string]: Emoji }> = computed(() => {
    let emojiMap = {};
    for (let emoji of getEmojiList()) {
        emojiMap[emoji.key] = emoji;
    }
    return emojiMap;
});

/**
 * Get an emoji by key
 */
export default function getEmoji(key: string): Emoji {
    return emojiMap.get()[key];
}
